module.exports = __WEBPACK_EXTERNAL_MODULE_90__;


//////////////////
// WEBPACK FOOTER
// external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"}
// module id = 90
// module chunks = 0